import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es',
    },
    theme: {
        dark: false,
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#1A1F2E',
                accent: '#35BDC8',
                success: '#4CAF50',
                warning: '#FFC107',
                error: '#F44336',
                main: '#1A1F2E',
                secondary: '#64748B',
                info: '#35BDC8',
                terciary: '#35BDC8',
                dark_blue: '#1A1F2E',
                medium_blue: '#35BDC8',
                light_blue: '#F8FAFC',
                custom_yellow: '#FFC107',
                custom_orange: '#FFC107',
                custom_red: '#F44336',
                custom_purple: '#805ad5'
            },
            dark: {
                //primary: '#DDDC00',
            }
        },
    }
});